import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import sk from './locales/sk.json';
import cs from './locales/cs.json';
import de from './locales/de.json';
import en from './locales/en.json';
import ru from './locales/ru.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sk: { translation: sk },
      cs: { translation: cs },
      de: { translation: de },
      en: { translation: en },
      ru: { translation: ru }
    },
    fallbackLng: 'sk',
    supportedLngs: ['sk', 'cs', 'de', 'en', 'ru'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    debug: false,
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
